<template lang="html">
  <v-container fluid>
    <lock v-if="currentDay != 6 && currentDay != 0" @status="bukaValidasiAktivitas"></lock>
    <!-- tampilan utama -->
    <template v-if="open || currentDay == 6 || currentDay == 0">
      <PanduanValidasi ref="panduan" @mulai="panel = 0"></PanduanValidasi>
      <v-row>
        <v-col cols="12" lg="7">
          <base-material-card icon="mdi-calendar">
            <calendar
              id="panduan-val-kalender"
              :days="days"
              :loading="loading"
              :backup="false"
              @on-select-date="setSelectedDate"
              @on-change-range="setRange"
            ></calendar>
          </base-material-card>
        </v-col>

        <v-col cols="12" lg="5">
          <base-material-card icon="mdi-account-check">
            <div class="d-flex align-center flex-wrap mb-3">
              <div class="mr-2">
                <div class="overline grey--text">Tanggal dipilih</div>
                <div class="subtitle-1 font-weight-medium orange--text text--darken-2">{{currentDate|formatTime}}</div>
              </div>
              <v-spacer></v-spacer>
              <v-chip v-if="totalMenunggu > 0" small color="info" class="mr-1">{{totalMenunggu}} menunggu bulan ini</v-chip>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon small :loading="loading" v-bind="attrs" v-on="on" @click="getValidasi()" aria-label="Muat ulang">
                    <v-icon small>mdi-refresh</v-icon>
                  </v-btn>
                </template>
                <span>Muat ulang</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon small v-bind="attrs" v-on="on" @click="$refs.panduan.mulai()" aria-label="Panduan">
                    <v-icon small>mdi-help-circle-outline</v-icon>
                  </v-btn>
                </template>
                <span>Panduan</span>
              </v-tooltip>
            </div>

            <!-- ringkasan sekaligus filter status -->
            <v-row dense id="panduan-val-ringkasan" class="mb-2">
              <v-col cols="4" v-for="s in ringkasan" :key="s.value">
                <div
                  v-ripple
                  role="button"
                  tabindex="0"
                  class="ringkasan text-center py-2"
                  :class="[s.bg, {'ringkasan--aktif': filter == s.value}]"
                  :style="{borderColor: filter == s.value ? $vuetify.theme.currentTheme[s.color] : 'transparent'}"
                  :aria-pressed="filter == s.value ? 'true' : 'false'"
                  @click="setFilter(s.value)"
                  @keyup.enter="setFilter(s.value)"
                >
                  <div class="ringkasan__jumlah" :class="s.color + '--text'">{{s.jumlah}}</div>
                  <div class="caption grey--text text--darken-2">
                    <v-icon x-small :color="s.color">{{s.icon}}</v-icon> {{s.text}}
                  </div>
                </div>
              </v-col>
            </v-row>

            <div id="panduan-val-pegawai" class="daftar pa-1">
              <template v-if="loading && days.length == 0">
                <v-skeleton-loader class="mb-3" v-for="i in [1,2,3]" :key="i"
                  type="list-item-avatar-two-line"
                ></v-skeleton-loader>
              </template>

              <v-expansion-panels v-else-if="pegawaiList.length > 0" v-model="panel" accordion>
                <v-expansion-panel v-for="p in pegawaiList" :key="p.nip">
                  <v-expansion-panel-header class="px-3">
                    <div class="d-flex align-center flex-wrap pegawai">
                      <v-avatar size="44" color="primary" class="mr-3">
                        <v-img v-if="p.foto && !fotoError[p.nip]" :src="p.foto" :alt="p.nama" @error="$set(fotoError, p.nip, true)"></v-img>
                        <span v-else class="white--text font-weight-medium">{{p.inisial}}</span>
                      </v-avatar>
                      <div class="pegawai__info">
                        <div class="font-weight-medium pegawai__nama">{{p.nama}}</div>
                        <div class="caption grey--text text--darken-1">{{p.keterangan}}</div>
                      </div>
                      <v-chip v-if="p.menunggu.length > 0" small color="info" class="mx-2 flex-shrink-0">
                        <v-icon x-small left>mdi-timer-sand</v-icon>{{p.menunggu.length}}
                      </v-chip>
                      <v-icon v-else color="success" class="mx-2">mdi-check-circle</v-icon>
                      <!-- tetap bisa diklik walaupun daftar aktivitas tertutup -->
                      <v-btn
                        v-if="p.menunggu.length > 0"
                        small
                        color="success"
                        class="panduan-val-semua my-1 mr-2 flex-shrink-0"
                        :loading="bulk.nip == p.nip"
                        :disabled="!!bulk.nip"
                        @click.stop="konfirmasiSemua(p)"
                        @keyup.stop
                        @keydown.stop
                      >
                        <v-icon small left>mdi-check-all</v-icon> Terima semua
                        <template v-slot:loader>
                          <span class="caption">Memproses {{bulk.selesai}}/{{bulk.total}}</span>
                        </template>
                      </v-btn>
                    </div>
                  </v-expansion-panel-header>

                  <v-expansion-panel-content>
                    <AktivitasValidasiItem
                      v-for="item in p.items"
                      :key="item.id"
                      :item="item"
                      :loading="!!loadingIds[item.id]"
                      @terima="terima"
                      @tolak="openTolak"
                    />
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>

              <div v-else class="d-flex align-center flex-column py-8 text-center">
                <template v-if="aktivitasHariIni.length == 0">
                  <v-icon size="56" color="grey lighten-1">mdi-calendar-blank-outline</v-icon>
                  <p class="paragraph mt-3 mb-0">Tidak ada aktivitas bawahan pada tanggal ini</p>
                </template>
                <template v-else>
                  <v-icon size="56" :color="filter == 'waiting' ? 'success' : 'grey lighten-1'">{{filter == 'waiting' ? 'mdi-check-decagram' : 'mdi-filter-remove-outline'}}</v-icon>
                  <p class="paragraph mt-3 mb-4">{{filter == 'waiting' ? 'Semua aktivitas pada tanggal ini sudah divalidasi' : 'Tidak ada aktivitas dengan status ini'}}</p>
                  <v-btn small outlined color="primary" @click="filter = null">Tampilkan semua</v-btn>
                </template>
              </div>
            </div>
          </base-material-card>
        </v-col>
      </v-row>
    </template>

    <!-- alasan penolakan -->
    <v-dialog v-model="dialogTolak" max-width="420px">
      <v-card>
        <v-card-title class="display-1 error--text">Tolak Aktivitas</v-card-title>
        <v-card-text>
          <p v-if="tolakItem" class="paragraph tolak__keterangan">{{tolakItem.keterangan}}</p>
          <v-form ref="formTolak" v-model="validTolak" lazy-validation @submit.prevent>
            <v-textarea
              v-model="alasan"
              outlined
              autofocus
              rows="3"
              counter="300"
              maxlength="300"
              label="Alasan penolakan"
              :rules="[rules.required]"
            ></v-textarea>
          </v-form>
        </v-card-text>
        <v-card-actions class="px-6 pb-4">
          <v-btn @click="dialogTolak = false">Batal</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="error" :loading="loadingTolak" @click="tolak">
            <v-icon small left>mdi-close</v-icon> Tolak
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- konfirmasi terima semua -->
    <v-dialog v-model="dialogSemua" max-width="420px">
      <v-card v-if="semuaPegawai">
        <v-card-title class="display-1 orange--text">Terima Semua Aktivitas</v-card-title>
        <v-card-text>
          <p class="paragraph mb-0">
            <b>{{semuaPegawai.menunggu.length}} aktivitas</b> milik <b>{{semuaPegawai.nama}}</b> pada {{currentDate|formatTime}} akan disetujui. Lanjutkan?
          </p>
        </v-card-text>
        <v-card-actions class="px-6 pb-4">
          <v-btn @click="dialogSemua = false">Batal</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="success" @click="terimaSemua">
            <v-icon small left>mdi-check-all</v-icon> Terima semua
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import _ from 'lodash'
import store from '@/store'
import moment from 'moment'
import AktivitasService from '@/services/AktivitasService'
import PenilaianService from '@/services/PenilaianService'
import Lock from '@/components/common/Lock'
import Calendar from '@/views/pelaksanaan/components/CalendarV2'
import AktivitasValidasiItem from './components/AktivitasValidasiItem'
import PanduanValidasi from './components/PanduanValidasi'

export default {
  components:{
    Lock,
    Calendar,
    AktivitasValidasiItem,
    PanduanValidasi,
  },

  data: () => ({
    open:false,
    selectedDate:'',
    startDate:'',
    endDate:'',
    days:[],
    loading:false,
    sudahDimuat:false,
    // null = semua, 'waiting', 'valid', 'invalid'
    filter:null,
    // daftar aktivitas setiap pegawai tertutup sampai diklik
    panel:null,
    fotoError:{},
    loadingIds:{},
    bulk:{
      nip:null,
      selesai:0,
      total:0,
    },

    dialogTolak:false,
    tolakItem:null,
    alasan:'',
    validTolak:true,
    loadingTolak:false,

    dialogSemua:false,
    semuaPegawai:null,

    rules:{
      required : value => !!(value && value.trim()) || 'tidak boleh kosong',
    },
  }),

  filters:{
    formatTime: function(value){
      moment.locale('id')
      return moment(value).format('dddd, Do MMMM YYYY')
    },
  },

  watch:{
    currentDate(){
      this.setFilterDefault()
    },

    filter(){
      this.panel = null
    },

    dialogTolak(val){
      if (!val){
        this.tolakItem = null
        this.alasan = ''
        if (this.$refs.formTolak){
          this.$refs.formTolak.resetValidation()
        }
      }
    }
  },

  computed:{
    currentDay(){
      return moment().day()
    },

    currentDate(){
      return this.selectedDate ? this.selectedDate : moment().format('YYYY-MM-DD')
    },

    aktivitasHariIni(){
      let day = this.days.find(x => x.tanggal == this.currentDate)
      return day && day.aktivitas ? day.aktivitas : []
    },

    ringkasan(){
      let jumlah = _.countBy(this.aktivitasHariIni, x => this.getStatus(x))
      return [
        {value:'waiting', text:'Menunggu', color:'info', bg:'blue lighten-5', icon:'mdi-timer-sand', jumlah:jumlah.waiting || 0},
        {value:'valid', text:'Disetujui', color:'success', bg:'green lighten-5', icon:'mdi-check-circle', jumlah:jumlah.valid || 0},
        {value:'invalid', text:'Ditolak', color:'error', bg:'red lighten-5', icon:'mdi-close-circle', jumlah:jumlah.invalid || 0},
      ]
    },

    // aktivitas pada tanggal yang dipilih, dikelompokkan per pegawai
    pegawaiList(){
      let groups = _.groupBy(this.aktivitasHariIni, 'nip18')

      let list = Object.keys(groups).map(nip => {
        let semua = groups[nip]
        let pegawai = (semua.find(x => x.pegawai) || {}).pegawai || {}
        let nama = pegawai.peg_nama || nip

        return {
          nip: nip,
          nama: nama,
          inisial: nama.split(' ').slice(0, 2).map(x => x.charAt(0)).join('').toUpperCase(),
          keterangan: [pegawai.jabatan, pegawai.golongan].filter(x => x).join(' • ') || nip,
          foto: pegawai.peg_foto ? process.env.VUE_APP_IMG_URL + pegawai.peg_foto : '',
          menunggu: semua.filter(x => !x.status),
          items: _.sortBy(semua.filter(x => !this.filter || this.getStatus(x) == this.filter), ['jam_mulai', 'menit_mulai']),
        }
      })

      return _.sortBy(list.filter(x => x.items.length > 0), 'nama')
    },

    // jumlah aktivitas yang belum divalidasi pada bulan yang ditampilkan
    totalMenunggu(){
      return _.sumBy(this.days, day => (day.aktivitas || []).filter(x => !x.status).length)
    }
  },

  created(){
    this.sinkron = _.debounce(this.sinkron, 800)
  },

  beforeDestroy(){
    this.sinkron.cancel()
  },

  methods:{
    bukaValidasiAktivitas(val){
      if (val == 'open'){
        this.open = true
      } else {
        this.open = false
      }
    },

    getStatus(item){
      return item.status ? item.status : 'waiting'
    },

    setSelectedDate(val){
      this.selectedDate = val
    },

    setRange({from, to}){
      if (from == this.startDate && to == this.endDate){
        return
      }
      this.startDate = from
      this.endDate = to
      this.getValidasi()
    },

    setFilter(val){
      this.filter = this.filter == val ? null : val
    },

    // dahulukan aktivitas yang masih menunggu validasi
    setFilterDefault(){
      this.filter = this.aktivitasHariIni.some(x => !x.status) ? 'waiting' : null
      this.panel = null
    },

    getValidasi(silent){
      let from = this.startDate
      let to = this.endDate
      if (!from || !to){
        return
      }
      if (!silent){
        this.loading = true
      }

      AktivitasService.getValidasiAktivitas({from: from, to: to}).then(response => {
        // abaikan response dari bulan yang sudah tidak ditampilkan
        if (from == this.startDate && to == this.endDate){
          this.days = response.data.data || []
          if (!silent){
            this.setFilterDefault()
          }
        }
      }).catch(error => {
        if (!silent){
          store.commit('snackbar/setSnack',{message:this.getErrorMessage(error, 'Gagal mengambil data validasi aktivitas'), color:'error'})
        }
      }).finally(()=>{
        if (!silent && from == this.startDate && to == this.endDate){
          this.loading = false
          if (!this.sudahDimuat){
            this.sudahDimuat = true
            this.$nextTick(() => {
              if (this.$refs.panduan){
                this.$refs.panduan.mulaiOtomatis()
              }
            })
          }
        }
      })
    },

    // samakan kembali data dengan server setelah validasi, tanpa indikator loading
    sinkron(){
      if (Object.keys(this.loadingIds).length > 0 || this.bulk.nip){
        return
      }
      this.getValidasi(true)
    },

    getErrorMessage(error, fallback){
      let data = error.response ? error.response.data : null
      if (!data){
        return fallback
      }

      let errors = data.errors
      if (errors && typeof errors == 'object'){
        errors = _.flatten(Object.values(errors))[0]
      }
      return errors || data.message || fallback
    },

    // perbarui status pada data lokal agar kalender & daftar langsung berubah
    tandai(id, tanggal, status, ket){
      let day = this.days.find(x => x.tanggal == tanggal)
      let item = day ? (day.aktivitas || []).find(x => x.id == id) : null
      if (!item || item.status){
        return
      }

      item.status = status
      if (ket){
        this.$set(item, 'keterangan_validasi', ket)
      }
      day.waiting = Math.max((day.waiting || 0) - 1, 0)
      if (status == 'valid'){
        day.approved = (day.approved || 0) + 1
      } else {
        day.rejected = (day.rejected || 0) + 1
      }
    },

    validasi(item, status, ket){
      let service = status == 'valid' ? PenilaianService.validasiAktivitasTerima : PenilaianService.validasiAktivitasTolak
      this.$set(this.loadingIds, item.id, true)

      return service(item.id, ket, item.nip18).then(response => {
        let res = response.data
        if (res.success){
          this.tandai(item.id, item.tanggal, status, ket)
        }
        return {ok: !!res.success, message: res.message}
      }).catch(error => {
        return {ok: false, message: this.getErrorMessage(error, 'Validasi aktivitas gagal disimpan')}
      }).finally(() => {
        this.$delete(this.loadingIds, item.id)
        this.sinkron()
      })
    },

    terima(item){
      this.validasi(item, 'valid', '').then(hasil => {
        store.commit('snackbar/setSnack',{message:hasil.message || (hasil.ok ? 'Aktivitas disetujui' : 'Validasi aktivitas gagal disimpan'), color:hasil.ok ? 'success' : 'error'})
      })
    },

    openTolak(item){
      this.tolakItem = item
      this.dialogTolak = true
    },

    tolak(){
      if (!this.tolakItem || !this.$refs.formTolak.validate()){
        return
      }
      this.loadingTolak = true

      this.validasi(this.tolakItem, 'invalid', this.alasan.trim()).then(hasil => {
        store.commit('snackbar/setSnack',{message:hasil.message || (hasil.ok ? 'Aktivitas ditolak' : 'Validasi aktivitas gagal disimpan'), color:hasil.ok ? 'success' : 'error'})
        if (hasil.ok){
          this.dialogTolak = false
        }
      }).finally(() => {
        this.loadingTolak = false
      })
    },

    konfirmasiSemua(pegawai){
      this.semuaPegawai = pegawai
      this.dialogSemua = true
    },

    async terimaSemua(){
      let pegawai = this.semuaPegawai
      this.dialogSemua = false
      if (!pegawai || this.bulk.nip){
        return
      }

      // satu per satu agar tidak membebani server
      let items = pegawai.menunggu.filter(x => !this.loadingIds[x.id])
      let berhasil = 0
      let pesanGagal = ''
      this.bulk = {nip: pegawai.nip, selesai: 0, total: items.length}

      for (let i = 0; i < items.length; i++){
        let hasil = await this.validasi(items[i], 'valid', '')
        if (hasil.ok){
          berhasil++
        } else {
          pesanGagal = pesanGagal || hasil.message
        }
        this.bulk.selesai = i + 1
      }

      this.bulk = {nip: null, selesai: 0, total: 0}
      this.sinkron()

      let gagal = items.length - berhasil
      if (gagal == 0){
        store.commit('snackbar/setSnack',{message:berhasil + ' aktivitas ' + pegawai.nama + ' disetujui', color:'success'})
      } else {
        store.commit('snackbar/setSnack',{message:berhasil + ' aktivitas disetujui, ' + gagal + ' gagal' + (pesanGagal ? ' (' + pesanGagal + ')' : ''), color:berhasil > 0 ? 'warning' : 'error'})
      }
    }
  },
}
</script>

<style lang="scss" scoped>
  .ringkasan{
    border: 2px solid transparent;
    border-radius: 10px;
    cursor: pointer;
    outline: none;
    transition: box-shadow .2s, border-color .2s;
    &:hover, &:focus{
      box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
    }
    &__jumlah{
      font-size: 24px;
      font-weight: 700;
      line-height: 1.2;
    }
  }
  .daftar{
    max-height: 560px;
    overflow: auto;
  }
  .pegawai{
    min-width: 0;
    &__info{
      min-width: 0;
      flex: 1 1 140px;
    }
    &__nama{
      line-height: 1.3;
      overflow-wrap: anywhere;
    }
  }
  .tolak__keterangan{
    font-size: 13px;
    white-space: pre-line;
    overflow-wrap: anywhere;
  }
</style>
